/** Build a URL for a file under `public/images/`. */
export function getPublicImageSrc(
  fileName: string,
  basename = process.env.PUBLIC_URL || ''
): string {
  const encoded = fileName
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');
  return `${basename}/images/${encoded}`;
}
